var exports = {
  "dz": "dropdownElementButtonText__2nTocx",
  "fy": "dropdownElementContainer__jbQOkl",
  "NS": "dropdownMenuOverlay__6dW9HN",
};

module.exports = exports;
